module.exports = __webpack_public_path__ + "static/media/homeNoatecGeneral.8605b354.png";